var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/utils/sites.jinja"] = require( "front/utils/sites.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/Footer/Footer.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/Footer/Footer.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n";
env.getTemplate("front/utils/sites.jinja", false, "assets/app/front/components/Footer/Footer.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "SITE_AVAILABILITY")) {
var t_7 = t_4.SITE_AVAILABILITY;
} else {
cb(new Error("cannot import 'SITE_AVAILABILITY'")); return;
}
context.setVariable("SITE_AVAILABILITY", t_7);
output += "\n\n<footer class=\"Footer NeedFixOnPopup\">\n\n    <div class=\"Footer-wrapper\">\n\n        <div class=\"Footer-columns2\">\n            <ul class=\"Footer-columns2-item\">\n                <li><a href=\"";
output += runtime.suppressValue((lineno = 9, colno = 33, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:contact"])), env.opts.autoescape);
output += "\">Contact</a></li>\n                <li><a href=\"";
output += runtime.suppressValue((lineno = 10, colno = 33, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:archives"])), env.opts.autoescape);
output += "\">ADG Archives</a></li>\n                <li><a href=\"";
output += runtime.suppressValue((lineno = 11, colno = 33, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:media"])), env.opts.autoescape);
output += "\">Media</a></li>\n            </ul>\n\n            <ul class=\"Footer-columns2-item\">\n                <li><a href=\"";
output += runtime.suppressValue((lineno = 15, colno = 40, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "domain_url"), "domain_url", context, [t_7,"index"])), env.opts.autoescape);
output += "\">Availability List</a></li>\n                <li><a href=\"";
output += runtime.suppressValue((lineno = 16, colno = 33, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:perspective"])), env.opts.autoescape);
output += "\">Perspective</a></li>\n                <li><a href=\"";
output += runtime.suppressValue((lineno = 17, colno = 33, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:press"])), env.opts.autoescape);
output += "\">Press</a></li>\n            </ul>\n        </div>\n\n        <div class=\"Footer-columns4\">\n            <ul class=\"Footer-columns4-item\">\n                <li><a href=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "footer")),"instagram"), env.opts.autoescape);
output += "\" target=\"_blank\">Instagram</a></li>\n                <li><a href=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "footer")),"facebook"), env.opts.autoescape);
output += "\" target=\"_blank\">Facebook</a></li>\n                <li><a href=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "footer")),"twitter"), env.opts.autoescape);
output += "\" target=\"_blank\">Twitter</a></li>\n            </ul>\n\n            <ul class=\"Footer-columns4-item\">\n                <li><a href=\"";
output += runtime.suppressValue((lineno = 29, colno = 33, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:privacy"])), env.opts.autoescape);
output += "\" target=\"_blank\">Privacy Policy</a></li>\n                <li><a href=\"";
output += runtime.suppressValue((lineno = 30, colno = 33, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:terms"])), env.opts.autoescape);
output += "\" target=\"_blank\">Terms of Use</a></li>\n                <li><a href=\"http://www.iatse.net\" target=\"_blank\">The Iatse</a></li>\n            </ul>\n\n            <div class=\"Footer-columns4-item\">\n                <div class=\"Footer-address\">\n                    <a href=\"https://www.google.com/maps/place/11969+Ventura+Blvd,+Studio+City,+CA+91604,+USA/@34.1437329,-118.3948317,17z/data=!3m1!4b1!4m5!3m4!1s0x80c2be07f9fa4a93:0x6285b8ff97f6c3d8!8m2!3d34.1437329!4d-118.392643\" target=\"_blank\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, env.getFilter("nl2br").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "footer")),"address"))), env.opts.autoescape);
output += "</a>\n                    <br>\n                    <a href=\"tel:";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "footer")),"phone"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "footer")),"phone"), env.opts.autoescape);
output += "</a>\n                </div>\n            </div>\n\n            <div class=\"Footer-columns4-item\">\n                <div class=\"Footer-logo\">\n                    ";
output += runtime.suppressValue((lineno = 44, colno = 42, runtime.callWrap(runtime.memberLookup((t_1),"svgSprite"), "macros[\"svgSprite\"]", context, ["logo","0 0 160 150",runtime.makeKeywordArgs({"caller": (function (){var macro_t_8 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_9 = "";;
frame = frame.pop();
return new runtime.SafeString(t_9);
});
return macro_t_8;})()})])), env.opts.autoescape);
output += "\n                </div>\n            </div>\n        </div>\n\n        <div class=\"Footer-copyright\">Local 800 / © ";
output += runtime.suppressValue(env.getFilter("datetime").call(context, runtime.contextOrFrameLookup(context, frame, "now"),"%Y"), env.opts.autoescape);
output += " art Directors Guild</div>\n\n    </div>\n\n</footer>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/Footer/Footer.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/Footer/Footer.jinja
// module id = 483
// module chunks = 0